export interface ParamsGuiasEnviadasRecibidas {
    fechaDesde: Date | string | null;
    fechaHasta: Date | string | null;
    idSucursal: number | null;
    tipoReporte: TipoReporte;
    condicionEntrega: CondicionEntrega | null;
    orden: Orden | null;
}

export enum TipoReporte
{
    GuiasEnviadas = 1,
    GuiasRecibidas = 2
}

export enum CondicionEntrega
{
    EAD = 1,
    EntregaOcurre = 2
}

export enum Orden
{
    FechaEmision = 1,
    Guia = 2,
    ClienteOrigen = 3,
    ClienteDestino = 4,
    SucursalDestino = 5
}


// WEBPACK FOOTER //
// ./app/models/reporteguiasenviadasrecibidas.ts